import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Calendar, SocialNetworkIcon } from 'components';
import { FlyoutSection } from 'containers';
import { LLCheckbox } from 'components/FormElements';
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';

var AdsPlannerFlyout = /*#__PURE__*/function (_Component) {
  _inherits(AdsPlannerFlyout, _Component);

  var _super = _createSuper(AdsPlannerFlyout);

  function AdsPlannerFlyout() {
    _classCallCheck(this, AdsPlannerFlyout);

    return _super.apply(this, arguments);
  }

  _createClass(AdsPlannerFlyout, [{
    key: "render",
    value: function render() {
      var _this = this;

      var curPlan = this.props.adsPlanner && this.props.adsPlanner.currentPlanId && this.props.adsPlanner[this.props.adsPlanner.currentPlanId] ? this.props.adsPlanner[this.props.adsPlanner.currentPlanId] : null;
      return /*#__PURE__*/React.createElement("div", null, !!this.props.adsPlanner && this.props.adsPlanner.usePlanner && /*#__PURE__*/React.createElement(FlyoutSection, {
        title: "RESULT BOXES"
      }, /*#__PURE__*/React.createElement(Checkbox, {
        label: "Budget",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'budget';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('budget', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Spent",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'spent';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('spent', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Page Likes",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'page_likes';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('page_likes', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Impressions",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'impressions';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('impressions', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Cost Per Action",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'cost_per_action';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('cost_per_action', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Days Left",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'days_left';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('days_left', val);
        }
      }), /*#__PURE__*/React.createElement(Checkbox, {
        label: "Clicks",
        style: {
          padding: 10
        },
        checked: curPlan && curPlan.resultStatTypes ? !!curPlan.resultStatTypes.find(function (s) {
          return s === 'clicks';
        }) : false,
        onCheck: function onCheck(e, val) {
          _this.props.handleResultStatChecked('clicks', val);
        }
      })));
    }
  }]);

  return AdsPlannerFlyout;
}(Component);

export { AdsPlannerFlyout as default };